var Modal = require('./modal');

var CheckboxModal = {};

CheckboxModal.init = function () {
  var $checkboxModals = document.querySelectorAll('.js-checkbox-modal');

  if ($checkboxModals) {
    [].map.call($checkboxModals, function ($checkbox) {
      $checkbox.removeEventListener('change', _changeOverflowHidden);
      $checkbox.addEventListener('change', _changeOverflowHidden);
    });
  }
};

function _changeOverflowHidden() {
  if (this.checked) {
    document.body.classList.add('overflow-hidden');
    setHash(this);
  } else {
    document.body.classList.remove('overflow-hidden');
    _removeHash();
  }
}

function _uncheckAll($checkboxModals) {
  [].map.call($checkboxModals, function ($checkbox) {
    $checkbox.checked = false;
  });

  document.body.classList.remove('overflow-hidden');
}

function checkByHash(hash) {
  var $checkboxModals = document.querySelectorAll('.js-checkbox-modal');

  if ($checkboxModals) {
    for (var i = 0; i < $checkboxModals.length; i++) {
      var $item = $checkboxModals[i];
      if (($item.dataset || {}).hash === hash) {
        $item.checked = true;
        return;
      }
    }
    _uncheckAll($checkboxModals);
  }
}

function _removeHash() {
  history.pushState('', document.title, window.location.pathname + window.location.search);
}

function setHash(modal) {
  var hash = (modal.dataset || {}).hash || '';
  location.hash = hash;
}

window.onhashchange = function () {
  checkByHash((location.hash || '').replace('#', ''));
};

$('body').on('click tap', '.js-hair-type', function (e) {
  e.preventDefault();

  var body = (document.querySelector('.hair-type') || {}).innerHTML;
  if (body) {
    Modal.open({
      title: 'Tipos de Cabelos',
      body: body,
      windowTopClass: 'modal-without-padding'
    });
  }
});

CheckboxModal.init();

module.exports = CheckboxModal;
